import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { label: 'AI Tools', path: '/ai-tools' },
    { label: 'Climate Strategy', path: '/climate-strategy' },
    { label: 'Case Studies', path: '/case-studies' },
    { label: 'Insights', path: '/insights' },
    { label: 'About', path: '/about' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header style={{
      background: 'var(--bg-primary)',
      borderBottom: '1px solid var(--border-subtle)',
      padding: '16px 7.6923%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'fixed',
      top: 0,
      width: '100%',
      height: '80px',
      zIndex: 1000,
      boxSizing: 'border-box'
    }}>
      <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{ 
          fontSize: '26px', 
          fontWeight: 700, 
          color: 'var(--brand-primary)',
          letterSpacing: '-0.8px'
        }}>
          Futura
        </div>
        <div style={{ 
          fontSize: '26px', 
          fontWeight: 300, 
          color: 'var(--text-primary)',
          letterSpacing: '-0.5px'
        }}>
          Softwares
        </div>
      </Link>

      {/* Desktop Navigation */}
      <nav style={{
        display: 'flex',
        alignItems: 'center',
        gap: '32px'
      }} className="desktop-nav">
        {navLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            style={{
              color: isActive(link.path) ? 'var(--brand-active)' : 'var(--text-muted)',
              textDecoration: 'none',
              fontSize: '18px',
              fontWeight: 400,
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = 'var(--text-primary)'}
            onMouseLeave={(e) => e.target.style.color = isActive(link.path) ? 'var(--brand-active)' : 'var(--text-muted)'}
          >
            {link.label}
          </Link>
        ))}
        <Link to="/contact" className="btn-primary" style={{ marginLeft: '16px' }}>
          Book a Call
        </Link>
      </nav>

      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="mobile-menu-btn"
        style={{
          display: 'none',
          background: 'transparent',
          border: 'none',
          color: 'var(--text-primary)',
          cursor: 'pointer',
          padding: '8px'
        }}
      >
        {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
      </button>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="mobile-menu" style={{
          position: 'fixed',
          top: '80px',
          left: 0,
          right: 0,
          background: 'var(--bg-primary)',
          borderBottom: '1px solid var(--border-subtle)',
          padding: '20px',
          display: 'none',
          flexDirection: 'column',
          gap: '16px'
        }}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMenuOpen(false)}
              style={{
                color: isActive(link.path) ? 'var(--brand-active)' : 'var(--text-muted)',
                textDecoration: 'none',
                fontSize: '18px',
                fontWeight: 400,
                padding: '8px 0'
              }}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/contact" className="btn-primary" onClick={() => setIsMenuOpen(false)}>
            Book a Call
          </Link>
        </div>
      )}

      <style>{`
        @media (max-width: 767px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
          .mobile-menu {
            display: flex !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
